import { jsPDF } from 'jspdf';
import html2canvas from 'html2canvas';

const downloadBtn = document.querySelector( 'a[title="download-pdf"]' );

if ( downloadBtn ) {
  downloadBtn.addEventListener( 'click', function ( e ) {
    e.preventDefault(); // Prevent default anchor behavior

    const doc = new jsPDF( 'p', 'pt', 'a4' );
    const margin = 40;
    const pageWidth = doc.internal.pageSize.getWidth();
    const pageHeight = doc.internal.pageSize.getHeight();
    const printableWidth = pageWidth - margin * 2;
    const printableHeight = pageHeight - margin * 2;

    const possibleClasses = ['e-col--pdf-content', 'e-row--pdf-content', 'e-div--pdf-content', 'e-stn--pdf-content'];
    const targetElement = Array.from( document.querySelectorAll( '*' ) ).find( el =>
      possibleClasses.some( cls => el.classList.contains( cls ) )
    );

    const downloadLink = document.querySelector( 'a[title="download-pdf"]' );

    if ( downloadLink ) {
      downloadLink.style.display = 'none';
    }

    targetElement.scrollIntoView( { behavior: 'smooth', block: 'start' } );

    html2canvas( targetElement, { 
      scale: 2,
      useCORS: true,
      allowTaint: false,
    } ).then( canvas => {

      if ( downloadLink ) {
        downloadLink.style.display = '';
      }

      const imgHeight = canvas.height;
      const imgWidth = canvas.width;

      const ratio = printableWidth / imgWidth;
      const scaledHeight = imgHeight * ratio;

      const totalPages = Math.ceil( scaledHeight / printableHeight );

      for ( let i = 0; i < totalPages; i++ ) {
        if ( i > 0 ) doc.addPage();

        const srcY = ( imgHeight / totalPages ) * i;
        const canvasPage = document.createElement( 'canvas' );
        canvasPage.width = imgWidth;
        canvasPage.height = imgHeight / totalPages;

        const ctx = canvasPage.getContext( '2d' );
        ctx.drawImage( canvas, 0, -srcY );

        const imgData = canvasPage.toDataURL( 'image/png' );
        const pageImgHeight = ( imgHeight / totalPages ) * ratio;

        doc.addImage( imgData, 'PNG', margin, margin, printableWidth, pageImgHeight );
      }
      
      const postTitle = document.querySelector( 'h1' )?.innerText.trim() || 'download';
      const sanitizedTitle = postTitle.replace( /[\\/:*?"<>|]/g, '' ).replace( /\s+/g, '-' ).toLowerCase();
      doc.save( `${sanitizedTitle}.pdf` );
    } );
  } );
}